import types from '../actionTypes';

export const imagesRequest = meta => ({
    type: types.IMAGES_REQUEST,
    meta,
});

export const imagesRequestCompleted = () => ({
    type: types.IMAGES_REQUEST_COMPLETED,
});
